<template>
    <div class="ma-4">
        <ClientNav/>
        <v-row dense>
            <v-col cols="12">
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="4">
                                    <v-select
                                        v-model="newType"
                                        label="Document Type"
                                        :items="type"
                                        @change="updateFields()"
                                        :readonly="readonly"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="4" v-if="newType === 'Mandatory'">
                                    <v-select
                                        label="Mandatory"
                                        v-model="newMandatory"
                                        :items="mandatory"
                                        :readonly="readonly"

                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="4" v-if="newType === 'Elective'">
                                    <v-select
                                        label="Elective"
                                        v-model="newElective"
                                        :items="elective"
                                        :readonly="readonly"

                                    ></v-select>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12">
                                    <v-textarea
                                        v-model="newFocus"
                                        label="Focus"
                                        outlined
                                        :readonly="readonly"

                                    ></v-textarea>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12">
                                    <v-textarea
                                        v-model="newDetails"
                                        label="Details"
                                        outlined
                                        :readonly="readonly"

                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <DatePicker
                                        :default-date="newDateIssued"
                                        v-model="newDateIssued"
                                        label="Date Issued"
                                    />
                                    <!--                                    <v-menu-->
                                    <!--                                        ref="menu"-->
                                    <!--                                        v-model="menu"-->
                                    <!--                                        :close-on-content-click="false"-->
                                    <!--                                        :return-value.sync="date"-->
                                    <!--                                        transition="scale-transition"-->
                                    <!--                                        offset-y-->
                                    <!--                                        min-width="auto"-->
                                    <!--                                    >-->
                                    <!--                                        <template v-slot:activator="{ on, attrs }">-->
                                    <!--                                            <v-text-field-->
                                    <!--                                                v-model="newDateIssued"-->
                                    <!--                                                label="Date Issued"-->
                                    <!--                                                prepend-icon="mdi-calendar"-->
                                    <!--                                                v-bind="attrs"-->
                                    <!--                                                v-on="on"-->
                                    <!--                                                clearable-->
                                    <!--                                                :readonly="readonly"-->

                                    <!--                                            ></v-text-field>-->
                                    <!--                                        </template>-->
                                    <!--                                        <v-date-picker-->
                                    <!--                                            v-model="newDateIssued"-->
                                    <!--                                            no-title-->
                                    <!--                                            scrollable-->
                                    <!--                                            :readonly="readonly"-->

                                    <!--                                        >-->
                                    <!--                                            <v-spacer></v-spacer>-->
                                    <!--                                            <v-btn-->
                                    <!--                                                text-->
                                    <!--                                                color="primary"-->
                                    <!--                                                @click="menu = false"-->
                                    <!--                                            >-->
                                    <!--                                                Cancel-->
                                    <!--                                            </v-btn>-->
                                    <!--                                            <v-btn-->
                                    <!--                                                text-->
                                    <!--                                                color="primary"-->
                                    <!--                                                @click="$refs.menu.save(date)"-->
                                    <!--                                            >-->
                                    <!--                                                OK-->
                                    <!--                                            </v-btn>-->
                                    <!--                                        </v-date-picker>-->
                                    <!--                                    </v-menu>-->
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <DatePicker
                                        :default-date="newDateRequested"
                                        v-model="newDateRequested"
                                        label="Date Requested"
                                    />
                                    <!--                                    <v-menu-->
                                    <!--                                        ref="menu2"-->
                                    <!--                                        v-model="menu2"-->
                                    <!--                                        :close-on-content-click="false"-->
                                    <!--                                        :return-value.sync="date"-->
                                    <!--                                        transition="scale-transition"-->
                                    <!--                                        offset-y-->
                                    <!--                                        min-width="auto"-->
                                    <!--                                    >-->
                                    <!--                                        <template v-slot:activator="{ on, attrs }">-->
                                    <!--                                            <v-text-field-->
                                    <!--                                                v-model="newDateRequested"-->
                                    <!--                                                label="Date Requested"-->
                                    <!--                                                prepend-icon="mdi-calendar"-->
                                    <!--                                                :readonly="readonly"-->
                                    <!--                                                v-bind="attrs"-->
                                    <!--                                                v-on="on"-->
                                    <!--                                                clearable-->
                                    <!--                                            ></v-text-field>-->
                                    <!--                                        </template>-->
                                    <!--                                        <v-date-picker-->
                                    <!--                                            v-model="newDateRequested"-->
                                    <!--                                            no-title-->
                                    <!--                                            scrollable-->
                                    <!--                                            :readonly="readonly"-->

                                    <!--                                        >-->
                                    <!--                                            <v-spacer></v-spacer>-->
                                    <!--                                            <v-btn-->
                                    <!--                                                text-->
                                    <!--                                                color="primary"-->
                                    <!--                                                @click="menu2 = false"-->
                                    <!--                                            >-->
                                    <!--                                                Cancel-->
                                    <!--                                            </v-btn>-->
                                    <!--                                            <v-btn-->
                                    <!--                                                text-->
                                    <!--                                                color="primary"-->
                                    <!--                                                @click="$refs.menu2.save(date)"-->
                                    <!--                                            >-->
                                    <!--                                                OK-->
                                    <!--                                            </v-btn>-->
                                    <!--                                        </v-date-picker>-->
                                    <!--                                    </v-menu>-->
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <DatePicker
                                        :default-date="newDateExpires"
                                        v-model="newDateExpires"
                                        label="Date Expires"
                                    />

                                    <!--                                    <v-menu-->
                                    <!--                                        ref="menu3"-->
                                    <!--                                        v-model="menu3"-->
                                    <!--                                        :close-on-content-click="false"-->
                                    <!--                                        :return-value.sync="date"-->
                                    <!--                                        transition="scale-transition"-->
                                    <!--                                        offset-y-->
                                    <!--                                        min-width="auto"-->
                                    <!--                                    >-->
                                    <!--                                        <template v-slot:activator="{ on, attrs }">-->
                                    <!--                                            <v-text-field-->
                                    <!--                                                v-model="newDateExpires"-->
                                    <!--                                                label="Date Expires"-->
                                    <!--                                                prepend-icon="mdi-calendar"-->
                                    <!--                                                :readonly="readonly"-->
                                    <!--                                                v-bind="attrs"-->
                                    <!--                                                v-on="on"-->
                                    <!--                                                clearable-->

                                    <!--                                            ></v-text-field>-->
                                    <!--                                        </template>-->
                                    <!--                                        <v-date-picker-->
                                    <!--                                            v-model="newDateExpires"-->
                                    <!--                                            no-title-->
                                    <!--                                            scrollable-->
                                    <!--                                            :readonly="readonly"-->

                                    <!--                                        >-->
                                    <!--                                            <v-spacer></v-spacer>-->
                                    <!--                                            <v-btn-->
                                    <!--                                                text-->
                                    <!--                                                color="primary"-->
                                    <!--                                                @click="menu3 = false"-->
                                    <!--                                            >-->
                                    <!--                                                Cancel-->
                                    <!--                                            </v-btn>-->
                                    <!--                                            <v-btn-->
                                    <!--                                                text-->
                                    <!--                                                color="primary"-->
                                    <!--                                                @click="$refs.menu3.save(date)"-->
                                    <!--                                            >-->
                                    <!--                                                OK-->
                                    <!--                                            </v-btn>-->
                                    <!--                                        </v-date-picker>-->
                                    <!--                                    </v-menu>-->
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12">
                                    <v-textarea
                                        v-model="newNotes"
                                        label="Notes"
                                        outlined
                                        :readonly="readonly"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <form enctype="multipart/form-data">
                                        <v-file-input
                                            v-model="newDocuments"
                                            class="pa-2"
                                            label="Upload Document"
                                            filled
                                            multiple
                                            prepend-icon="mdi-camera"
                                            accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                            @change="imgSelected"
                                            :readonly="readonly"

                                        >
                                            <template #selection="{ text, index }">
                                                <v-chip small label close color="primary"
                                                        @click:close="deleteChip(index)">{{ text }}
                                                </v-chip>
                                            </template>
                                        </v-file-input>
                                    </form>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-select
                                        :items="statusList"
                                        label="Status"
                                        v-model="newStatus"
                                    ></v-select>
                                </v-col>
                                <v-carousel v-if="imageDetails.length > 0">
                                    <template v-for="(item, index) in imageDetails">
                                        <v-carousel-item :key="index">
                                            <v-row class="flex-nowrap" style="height:100%">
                                                <v-img :src="item.AWSLink">
                                                    <v-btn color="error" dark right @click="removeImage(item, index)" class="image-btn">
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                    <v-row class="fill-height"
                                                           align="center"
                                                           justify="center"
                                                    >
                                                        <div
                                                            style="color: #000;padding-top: 30%;">
                                                            {{ item.Name }}
                                                        </div>
                                                    </v-row>

                                                </v-img>

                                            </v-row>
                                        </v-carousel-item>
                                    </template>
                                </v-carousel>

                                <template v-if="pdfDetails.length > 0">
                                    <v-col cols="12" sm="12" md="12">
                                        <div v-for="(item, i) in pdfDetails"
                                             :key="i"
                                        >
                                            <LoadPDF
                                                :pdfFile="item.aws"
                                                :pdfName="item.name"
                                            />
                                        </div>
                                    </v-col>
                                </template>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions v-if="!directCare">
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrintModal()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="!newDocument"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn class="white--text" color="#259647" @click="addDoc()" :disabled="isSavingImage"
                               v-if="newDocument">Save
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="updateDoc()" :disabled="isSavingImage"
                               v-if="!newDocument && isActive">Update
                        </v-btn
                        >
                        <v-btn color="blue darken-1" text @click="close" :disabled="isSavingImage">Cancel</v-btn>
                    </v-card-actions>

                    <v-card-actions v-if="directCare">
                        <v-spacer></v-spacer>

                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../../components/ClientNav'
import Foot from '../../../components/Footer'
import moment from 'moment'
import fileRenamer from '../../../mixins/fileRenamer';
import LoadPDF from '../../../components/LoadPDF.vue';
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
import {displayError, displaySuccess, displayInfo} from "@/service/notification-message.service";
import PrintUtil from "../../../../utils/print-util";


const url = require("../../../client_config/config").url;

export default {
    mixins: [fileRenamer],
    components: {
        DatePicker,
        ClientNav,
        Foot,
        LoadPDF,
    },
    data: function () {
        return {
            headers: [
                {
                    text: 'Document Type',
                    align: 'start',
                    sortable: false,
                    value: 'Type',
                },
                {text: "Mandatory", value: "Mandatory"},
                {text: "Elective", value: "Elective"},
                {text: "Date Issued", value: "DateIssued"},
                {text: "Date Expires", value: "DateExpires"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            tab: null,
            items: ["Active Documents", "Expired Documents"],
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            menu2: false,
            menu3: false,
            dialog: false,
            editDoc: false,
            newDoc: false,
            msg: false,
            mandatoryPicked: false,
            electivePicked: false,
            text: "",
            docs: [],
            expired: [],
            tempData: [],
            statusList: [
                "Current",
                "Archived"
            ],
            clientID: this.$route.params.clientID,
            documentId: this.$route.params.id,
            token: localStorage.getItem('token'),
            type: ["Mandatory", "Elective"],
            mandatory: [
                "Annual PCP",
                "Annual Skills Assessment",
                "Annual Physical Exam",
                "Authorization for Emergency Medical Aid",
                "Authorization to Disclose Health Information",
                "Authorization for Medication Administration by DSS",
                "Auth for Restrictive Interventions",
                "Behavior Assessment",
                "Behavior Support Plan",
                "Consent for Med Administration",
                "Consent for Rights Restrictions",
                "Consent to Receive Services",
                "Consents and Authorizations",
                "DSPD RElease of Information",
                "DWS Authorization to Disclose Medical Eligibility",
                "DWS Authorization to Release Information",
                "DWS Authorization to Release Information to Third Party",
                "Human Righs - HRC", "Human Rights and Grievance Procedure",
                "HRC/BIC Notes",
                "MAAT",
                "Medical Clearance",
                "Medical Treatement Consent Form",
                "My Vision/Support Plan Signature Page",
                "OTC Standing Orders",
                "PCP Signature Sheet",
                "PCSP", "Release of Non-Medical Information",
                "Request and Authorization for Tests and Medical Records",
                "Responsibilities Agreement",
                "Risk and Support Screener",
                "RHS Provider Consents",
                "Service Authorization",
                "Service Plan",
                "Social Assessment",
                "Support Strategies",
                "Statement of Choice",
                "Voc Rehab",
                "Voter Registration",
                "Waiver Level of Care Determination",
                "Wellsky Facesheet",
            ],
            elective: [
                "Abuse/Neglect/Exploitation",
                "Asipiration/Choking",
                "Behavior Intervention",
                "Compromised Environment",
                "Debit Card",
                "Drug/Alcohol",
                "EBT Card",
                "Fatality",
                "Hospital",
                "Injury",
                "Immunizations",
                "Medication Errors",
                "Missing Person",
                "Property Destruction",
                "School Behavior Intervention Plan",
                "School IEP",
                "School Psychoeducational Evaluation",
                "Seizure",
                "Suicide Attempt/Threat",
                "Theft",
                "Other (Describe)"],
            titleForm: "New Annual Document",
            docID: "",
            newType: "",
            newMandatory: "",
            newElective: "",
            newFocus: "",
            newDetails: "",
            newDateIssued: "",
            newDateRequested: "",
            newDateExpires: "",
            newNotes: "",
            newStatus: "Current",
            imageDetails: [],
            pdfDetails: [],
            newDocuments: [],
            newDocumentsImage: "",
            uploadImg: "",
            readonly: false,
            editedIndex: -1,
            directCare: false,
            editedItem: {
                type: "",
                mandatory: "",
                elective: "",
                focus: "",
                details: "",
                dateIssued: "",
                dateRequested: "",
                dateExpires: "",
                notes: "",
                documents: "",
            },
            defaultItem: {
                type: "",
                mandatory: "",
                elective: "",
                focus: "",
                details: "",
                dateIssued: "",
                dateRequested: "",
                dateExpires: "",
                notes: "",
                documents: "",
            },
            isLoading: true,
            search: "",
            selectedProgram: '',
            programs: [],
            newDocument: false,
            isSavingImage: false,
            isActive: false,
        };
    },

    computed: {
        clientName() {
            return this.$store.state.clients.client.Name;
        }
    },

    watch: {},

    created() {
        this.newDocument = this.$route.query.newAnnualDocument === 'true'
        this.isActive = this.$route.query.active === 'true'

        this.getUnits();
        if (localStorage.getItem('userRole') === 'Direct Care Staff' ||
            localStorage.getItem('userRole') === 'Shift Lead' ||
            localStorage.getItem('userRole') === 'Assistant Manager' ||
            localStorage.getItem('userRole') === 'House Manager'
        ) {
            this.directCare = true;
            this.readonly = true;
        }
    },

    mounted() {
        if (!this.newDocument) {
            this.getAnnualDocument();
        }
        window.addEventListener('keydown', async (event) => {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, this.downloadUrl, this.documentId, this.token,'AnnualDocument');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.documentId, this.token,'AnnualDocument');
        });
    },

    methods: {

        initialize() {
            this.docs = [];
        },

        viewDoc(item) {

            this.newType = item.Type;
            this.newMandatory = item.Mandatory;
            this.newElective = item.Elective;
            this.newFocus = item.Focus;
            this.newDetails = item.Details;
            this.newDateIssued = moment(item.DateIssued).format("YYYY-MM-DD");
            this.newDateRequested = moment(item.DateRequested).format("YYYY-MM-DD");
            this.newDateExpires = moment(item.DateExpires).format("YYYY-MM-DD");
            this.newStatus = item.Status;
            if (item.DateExpires === "Invalid date") {
                this.newDateExpires = "";
            }
            this.newNotes = item.Notes;

            if (item.documents.length > 0) {
                const tempData = [];

                for (let i = 0; i < item.documents.length ; i++) {
                    tempData.push({
                        name: item.documents[i].Name,
                    });

                    let fileExt = item.documents[i].AWSLink.split('.').pop();

                    if (fileExt === "pdf") {
                        this.pdfDetails.push(
                            {
                                name: item.documents[i].Name,
                                id:   item.documents[i]._id,
                                aws:  item.documents[i].AWSLink   
                            }
                        );
                    } else {
                        this.imageDetails.push(item.documents[i]);
                    }
                }

                this.newDocuments = tempData;
            }
        },

        deleteChip(index) {
            // Prompt here with text if required
            this.newImage.splice(index, 1);
        },

        clear() {
            this.newType = "";
            this.newMandatory = "";
            this.newElective = "";
            this.newFocus = "";
            this.newDetails = "";
            this.newDateIssued = "";
            this.newDateRequested = "";
            this.newDateExpires = "";
            this.newNotes = "";
            this.newDocuments = [];
            this.newDocumentsImage = "";
            this.newStatus = "";
        },

        close() {
            this.$router.go(-1);
            this.clear()
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
            this.pdfDetails = [];
            this.imageDetails = [];
        },

        async updateDoc() {
            this.isLoading = true;
            let req_body = {
                Type: this.newType,
                Mandatory: this.newMandatory,
                Elective: this.newElective,
                Focus: this.newFocus,
                Details: this.newDetails,
                DateIssued: this.newDateIssued,
                DateRequested: this.newDateRequested,
                DateExpires: this.newDateExpires,
                Notes: this.newNotes,
                Status: this.newStatus,
            }

            try {
                const response = await axios.put(`${url}/annualDocs/${this.documentId}`, req_body);

                if (response.status !== 200) {
                    displayError("There was an error updating the document.");
                    return;
                }

                if (this.uploadImg.length) {
                    this.isSavingImage = true;
                    displayInfo("Uploading image, please wait...");
                    await this.saveImg();
                }

                displaySuccess("The document has been updated successfully.");
                this.getDocs();
            } catch (error) {
                displayError("Failed to upload image: " + (error.response && error.response.data && error.response.data.msg || "An unexpected error occurred."));
            } finally {
                this.isSavingImage = false;
                this.isLoading = false;
                this.close();
            }
        },

        async getAnnualDocument() {
            this.isLoading = true;
            this.expired = [];
            this.docs = [];

            await axios.get(`${url}/annualDocs/${this.documentId}`)
                .then(res => {
                    const tempData = res.data.doc;
                    this.viewDoc(tempData);
                })
                .catch(error => {
                    console.error('Error fetching documents:', error);
                })
                .finally(() => this.isLoading = false);
        },

        getDocs() {
            this.isLoading = true;
            this.expired = [];
            this.docs = [];

            axios.get(`${url}/annualDocs/client/${this.clientID}?program=${this.selectedProgram}`).then(res => {
                let tempData = []
                tempData = res.data.docs;

                let today = moment(new Date()).format("YYYY-MM-DD")

                for (let i = 0; i < tempData.length; i++) {
                    let expiration = moment(tempData[i].DateExpires).format("YYYY-MM-DD")
                    if (moment(expiration).isBefore(today)) {
                        this.expired.push((tempData[i]))

                    } else {
                        this.docs.push(tempData[i])

                    }
                }
            }).finally(() => this.isLoading = false);
        },


        getUnits() {
            axios.get(`${url}/units`).then(async res => {
                this.programs = res.data.units;
            });
        },
        getCodes: function () {
            axios.get(`${url}/codes`).then(async res => {
                this.codes = res.data.codes;

            });
        },

        async addDoc() {
            let req_body = {
                Type: this.newType,
                Mandatory: this.newMandatory,
                Elective: this.newElective,
                Focus: this.newFocus,
                Details: this.newDetails,
                DateIssued: this.newDateIssued,
                DateRequested: this.newDateRequested,
                DateExpires: this.newDateExpires,
                Notes: this.newNotes,
                Status: this.newStatus,
                ClientID: this.clientID,
            };

            try {
                const response = await axios.post(`${url}/annualDocs`, req_body);
                this.documentId = response.data._id;

                if (response.status !== 200) {
                    displayError("There was an error updating the document.");
                    return;
                }

                if (this.uploadImg.length) {
                    this.isSavingImage = true;
                    displayInfo("Uploading image, please wait...");
                    await this.saveImg();
                }
                displaySuccess("The document has been created successfully.");
                this.getDocs();
            } catch (error) {
                displayError("Failed to upload image: " + (error.response && error.response.data && error.response.data.msg || "An unexpected error occurred."));
            } finally {
                this.isSavingImage = false;
                this.isLoading = false;
                this.close();
            }
        },

        async imgSelected(e) {
            const data = {
                userName: this.clientName,
                formName: this.mandatoryPicked ? this.newMandatory : this.newElective,
                date: this.newDateIssued
            }
            this.uploadImg = await this.fileRenamer(e, data);
        },

        async saveImg() {
            this.message = "";
            for (let i = 0; i < this.uploadImg.length; i++) {
                await this.uploadFiles(this.uploadImg[i]);
            }
        },

        async uploadFiles(file) {
            const formData = new FormData();
            formData.append('annualDoc-img', file);
            let ct = {headers: {"content-type": "multipart/form-data"}};
            await axios.post(`${url}/annualDocs/imguploader/${this.documentId}/${this.clientID}`, formData, ct)
                .then(res => {
                    console.log({uploadFiles: res});
                })
                .catch(err => {
                    console.log(err);
                });
        },

        updateFields() {
            if (this.newType === 'Mandatory') {
                this.mandatoryPicked = true
                this.electivePicked = false
            } else if (this.newType === 'Elective') {
                this.electivePicked = true
                this.mandatoryPicked = false
            }
        },

        async removeImage(item, i){
            await axios.delete(`${url}/documents/${item._id}`)
            this.imageDetails.splice(i, 1);
        },

        async generateDownloadUrl() {
            return `${url}/annualDocs/print?id=${this.documentId}`;
        },

        async showPrintModal() {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(this.downloadUrl, this.documentId, this.token,'AnnualDocument');
        },

    },
}
</script>
<style>

.btn-program {
    margin-top: 30px;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}
</style>
